<template>
    <div class="app">
        <Header title="学生过程评价" type="0" route="/homeIndex"></Header>
        <van-field readonly clickable name="picker" :value="xqvalue" label="学年学期" placeholder="点击选择学期" @click="xqshowPicker = true" style="width: 100%" />
        <van-popup v-model="xqshowPicker" position="bottom">
            <van-picker show-toolbar :columns="semesterColumns" @confirm="xqonConfirm" @cancel="xqshowPicker = false" />
        </van-popup>
        <van-field readonly required clickable name="picker" :value="flvalue" label="评价分类" placeholder="点击选择分类" @click="flshowPicker = true" />
        <van-popup v-model="flshowPicker" position="bottom">
            <van-picker value-key="label" show-toolbar :columns="evaluateColumns" @confirm="flonConfirm" @cancel="flshowPicker = false" />
        </van-popup>
        <van-cell title="上课日期" :value="date" @click="show = true" />
        <van-calendar v-model="show" :min-date="mixDate" :max-date="maxDate" @confirm="onConfirm" color="#7469F8" />
        <!-- <NOdata v-if="dataList == 0" title="暂无数据~"></NOdata> -->
        <div class="info" v-for="(item, index) in dataList" :key="index">
            <div class="infoBox">
                <div class="boxl">
                    <div class="p">
                        <p>教师:{{ item.jsxm }}[{{ item.jgh }}]</p>
                        <p>学院:{{ item.dwmc }}</p>
                        <p>课程:{{ item.kcmc }}</p>
                        <p>学时:{{ item.zxs }}</p>
                        <p>节次:{{ item.kcsj }}</p>
                        <p>总评分:{{ item.zpf }}</p>
                    </div>
                    <div class="boxr">
                        {{ item.sfpj == '1' ? '已评' : '未评' }}
                    </div>
                </div>
                <div class="bottomButton">
                    <button type="primary" @click="studentEvaluation(item)">
                        {{ item.sfpj == '1' ? '查看' : '评价' }}
                    </button>
                    <button type="primary" @click="dialogue(item, xqvalue)">
                        留言
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Api } from '@/utils/axios';
import Vue from 'vue';
import { Picker, Toast } from 'vant';
Vue.use(Picker);
export default {
    data() {
        return {
            xqvalue: '',
            flvalue: '',
            xqshowPicker: false,
            flshowPicker: false,
            semesterColumns: [],
            evaluateColumns: [],
            date: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
            show: false,
            dataList: [],
            flId: '',
            mixDate: new Date(2000, 0, 1),
            maxDate: new Date(),
            xnxqList: []
        };
    },
    created() {
        this.getXnxq();
    },
    activated() {
        this.getXnxq();
    },
    methods: {
        //学年学期
        async getXnxq() {
            const res = await Api.getXnxq();
            res.data.forEach((item) => {
                this.semesterColumns.push({
                    text: item.xnxq01id,
                    value: item.xnxq01id
                });
            });
            this.xqvalue = res.data[0].xnxq01id;
            this.getpjflList();
        },
        //学年学期弹框
        xqonConfirm(e) {
            console.log('value:', e);
            this.xqvalue = e.value;
            this.xnxqList = e.value;
            this.xqshowPicker = false;
            this.getxsgcpjList();
        },
        //评价分类
        async getpjflList() {
            this.evaluateColumns = [];
            const flres = await Api.getpjflList();
            this.evaluateColumns = flres.data.map((item) => {
                return {
                    label: item.pjflmc,
                    value: item.id
                };
            });
            this.flvalue = flres.data[0].pjflmc;
            this.flId = flres.data[0].id;
            this.getxsgcpjList();
        },
        //评价分类弹框
        flonConfirm(val) {
            this.flvalue = val.label;
            this.flId = val.value;
            this.flshowPicker = false;
            this.getxsgcpjList();
        },
        //日期
        formatDate(date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        //日期弹框
        onConfirm(date) {
            this.show = false;
            this.date = this.formatDate(date);
            this.getxsgcpjList();
        },
        //教师信息
        async getxsgcpjList() {
            const params = {
                xnxq: this.xqvalue,
                pjflid: this.flId,
                rq: this.date
            };
            const res = await Api.getxsgcpjList(params);
            this.dataList = res.data;
        },
        studentEvaluation(item) {
            if (item.sfsjfw == '0') {
                Toast('未到评价时间!');
                return false;
            }
            this.$router.push({
                path: '/studentEvaluation/index',
                query: {
                    item: item,
                    pjflId: this.flId
                }
            });
            // console.log('item: ',item);
            // if(item.sfsjfw == 0){

            // }
        },
        dialogue(item, xqvalue) {
            this.$router.push({
                path: '/dialogue/index',
                query: {
                    item: item,
                    xqvalue: xqvalue
                }
            });
        }
    }
};
</script>

<style scoped lang="less">
.van-cell__value {
    margin-right: 154px;
    color: #323233;
}

.van-field__control:read-only {
    width: 200px;
}

.info {
    width: 100%;
    height: 100%;
    margin-top: 5px;
    background-color: #f8f8f8;
}

.infoBox {
    display: flex;
    align-items: center;
    flex-direction: column;
}

.boxl {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.boxl p {
    padding: 3px 0;
}
.p {
    margin: 0 30px;
}
.bottomButton {
    display: flex;
    justify-content: center;
    margin-top: 5px;
}

.bottomButton > button {
    width: 50px;
    height: 50px;
    margin: 10px;
    background-color: #7469f8;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/processEvaluation/index.vue